type IsImpersonateUserAllowed = (email: string | null | undefined) => boolean;

const JFROG_IMPERSONATE_EMAIL = /^(.+)-impersonate-(.+)@jfrog\.com$/i;

const isImpersonateUserAllowed: IsImpersonateUserAllowed = (email) => {
  if (!email?.trim()) {
    return false;
  }

  return JFROG_IMPERSONATE_EMAIL.test(email.trim());
};

export default isImpersonateUserAllowed;
